import { useEffect, useState } from 'react';
import axios from 'common/AxiosAuth';
import { LargeButton, InfoMessage, DescriptionBar, MenuTab, Grid, Button } from 'components';
import { Message } from 'types/message';

import { InformationCircleOutlineIcon } from 'assets/svgs';
import { PaidScheduleGridData, UnPaidScheduleGridData } from './types';
import { unPaidScheduleGrid, s3Status } from './utils';

const MENU_INDEX = {
  PENDING: 0,
  COMPLETE: 1
};

const UnPaidSchedule = () => {
  const [unPaidScheduleGridData, setUnPaidScheduleGridData] = useState<UnPaidScheduleGridData[]>([]);
  const pageSize = 10; // 페이징처리 기준
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  useEffect(() => {
    // 페이지가 변경될 때마다 데이터 요청
    getUnPaidSchedule(currentPage);
  }, [currentPage]);

  const getUnPaidSchedule= async (pageNum: number) => {
    const res = await axios.get(`/api/admin/schedule/unpaid/${pageNum}`);
    const { scheduleList = [], totalElement = 0 } = res.data;
    console.log('unpaidscheduleList Data:', scheduleList); 
    const unPaidScheduleGridData = scheduleList.map((item: any) =>{
      return {
        id:item.id,
        memberId:item.memberId,
        startTime:item.startTime,
        endTime:item.endTime,
        status:item.status,
        direction:item.direction,
        band:item.band,
        name:item.name,
        email:item.email,
        isPayment:item.isPayment,
      };
    });
    setUnPaidScheduleGridData(unPaidScheduleGridData);
    // 총 페이지 수 계산
    const totalPages = Math.ceil(totalElement / pageSize);
    setTotalPages(totalPages);
  };

  return (
    <div className="flex-1">
      <Grid
        gridColumns={unPaidScheduleGrid}
        gridData={unPaidScheduleGridData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        options={{
          useFilter: false,
          useCheckbox: false,
          usePagination: {
            use: true,
            maxPage: totalPages, // 총 페이지 수 반영
          },
          customCell: {
            status: (value) => {
              const status = s3Status[value] || s3Status.UNKNOWN;
              return (
                <div title={value}>
                  <div className={`flex h-6 w-fit items-center rounded-full border px-3 ${status.className}`}>
                    <span className="text-nowrap text-small font-regular">{status.title}</span>
                  </div>
                </div>
              );
            },
            isPayment: (value) => {
              const isPaid = value === true || value === 'true';
              const status = isPaid 
                ? { title: 'Paid', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' }
                : { title: 'Unpaid', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' };
              return (
                <div title={isPaid ? 'Paid' : 'Unpaid'}>
                  <div className={`flex h-6 w-fit items-center rounded-full border px-3 ${status.className}`}>
                    <span className="text-nowrap text-small font-regular">{status.title}</span>
                  </div>
                </div>
              );
            },
          },
        }}
      />
    </div>
  );
};

export default UnPaidSchedule;
